import config from '@/config'

export const accountantImageUrl = (accountantId: number) => `${config.apiUrl}accountants/${accountantId}/image`
